import { createI18n } from 'vue-i18n';
import en from './locales/en.json';
import fr from './locales/fr.json';

// Get browser language or default to French
function getBrowserLocale() {
  const navigatorLocale = navigator.language || navigator.userLanguage;

  if (!navigatorLocale) {
    return 'fr';
  }

  // Extract just the language code (e.g., 'en' from 'en-US')
  const locale = navigatorLocale.trim().split(/-|_/)[0];

  // Check if we support this locale
  if (locale === 'en' || locale === 'fr') {
    return locale;
  }

  // Default to French
  return 'fr';
}

// Get saved locale from localStorage or use browser locale
function getStartingLocale() {
  const savedLocale = localStorage.getItem('user_locale');
  if (!savedLocale) {
    const browserLocale = getBrowserLocale();
    localStorage.setItem('user_locale', browserLocale);
    return browserLocale;
  }
  return savedLocale;
}

const i18n = createI18n({
  legacy: false, // Use Composition API mode
  locale: getStartingLocale(),
  fallbackLocale: 'fr',
  messages: {
    en,
    fr,
  },
  globalInjection: true,
});

export default i18n;
